export default __webpack_public_path__ + "static/media/framepolitica.75ea0677.svg";